import type { Building } from "building-types/building/buildingTypes";
import type { Doc } from "building-types/doc";
import type { TargetedOpeningSettings } from "building-types/openings/opening";
import type { HeaderFramingSettings } from "building-types/settings/headerFramingSettings";
import type { WallCatalogSettings } from "building-types/settings/wallCatalogSettings";
import type { WallFramingSettings } from "building-types/settings/wallFramingSettings";
import type { WallFraming } from "building-types/walls/wallFramingTypes";
import type { RWTable, Table } from "common/data/table";
import { makeWallFraming } from "./wallFraming";

export interface MakeBuildingWallFramingParams
  extends Pick<Building, "levels" | "walls" | "planarGraphPerimeters">,
    Pick<Doc, "headerAssemblies" | "framingComponents"> {
  readonly wallCatalogSettings: WallCatalogSettings;
  readonly wallFramingSettings: WallFramingSettings;
  readonly targetedOpeningSettings: TargetedOpeningSettings;
  readonly headerFramingSettings: HeaderFramingSettings;
}

export function makeBuildingWallFraming({
  levels,
  walls,
  wallFramingSettings,
  wallCatalogSettings,
  planarGraphPerimeters,
  targetedOpeningSettings,
  headerFramingSettings,
  headerAssemblies,
  framingComponents,
}: MakeBuildingWallFramingParams): Table<WallFraming[]> {
  const wallFramingSystems: RWTable<WallFraming[]> = {};

  for (const levelId in levels) {
    wallFramingSystems[levelId] = makeWallFraming({
      level: levels[levelId],
      wallSystem: walls[levelId],
      planarGraphPerimeter: planarGraphPerimeters[levelId],
      wallFramingSettings,
      wallCatalog: wallCatalogSettings,
      targetedOpeningSettings,
      headerFramingSettings,
      headerAssemblies,
      framingComponents,
    });
  }

  return wallFramingSystems;
}
